import { formatErrorToString } from '../helpers';

export class ResponseError extends Error {
  status: number | undefined = 0;
  errors: any;
  global: any;
  retryAfter: number | null;

  constructor(
    message: string,
    errors?: any,
    global?: any,
    status?: number,
    retryAfter?: number | null,
  ) {
    super(message);
    this.errors = errors;
    this.global = global;
    this.status = status;
    this.retryAfter = retryAfter ?? null;
  }
}

export const parseResponseErrors = (
  body: any,
  status: number,
  retryAfter?: number | null,
) => {
  if (!body) return new ResponseError('', null, [], status, retryAfter);
  let rawErrors = body;
  if (body.errors) {
    if (body.batch_error_count) {
      rawErrors = body.errors.reduce(
        (errors: any, itemErrors: any) => ({ ...errors, ...itemErrors.errors }),
        {},
      );
    } else {
      rawErrors = body.errors;
    }
  }

  if (body.message && body.code && typeof body.code === 'number') {
    rawErrors = body.message;
  } else if (body.quota_name) {
    rawErrors = body.quota_name;
  }

  return new ResponseError(
    formatErrorToString(rawErrors),
    rawErrors,
    Array.isArray(rawErrors) ? rawErrors : [],
    status,
    retryAfter,
  );
};
